import{__module as r}from"../../_virtual/index3.js";import{f as o}from"./factoryWithThrowingShims.js";r.exports=o();var s=r.exports;export{s as p};
